export enum OperationType {
    SyncData
}
